/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const formatNumber = (number?: number, roundDigits?: number) =>
  number?.toLocaleString('en-US', {
    maximumFractionDigits: roundDigits ?? 2,
  });
